<template>
  <div class="product_iformation">

    <div class="product_iformation_grid cart_header">
      <p>Proizvod</p>
      <div></div>
      <p>Količina</p>
      <p class="last_right">Ukupno</p>
      <div></div>
    </div>

    <div class="product_iformation_grid product" v-for="(item, index) in getCartItems" :key="index">
      <a :href="item.model.path" class="product_img">
        <img :src="item.model.cartImage" :alt="item.model.short" width="270" height="400">
        <h2>{{ item.model.html_title }} {{ item.name }}</h2>
      </a>
      <div class="left">
        <h2><a :href="item.model.path">{{ item.model.html_title }} {{ item.name }}</a></h2>
      </div>

      <p class="quantity">{{ item.qty }}</p>
      <p class="last_right">{{ formatPrice(item.model.discountedPrice * item.qty) }} rsd</p>
    </div>

    <div class="cart_total">
	    <p><span>Ukupno:</span> <span>{{ formatPrice(getSubTotalPrice) }} rsd</span></p>

      <p v-if="getCoupon"><span>Popust: </span>
        <span>-{{ formatPrice(getCoupon.discountPrice) }} rsd</span>
      </p>
	    <p v-else><span>Popust: </span>
		    <span>-{{ formatPrice(getSubTotalPrice - getTotalPrice) }} rsd</span>
	    </p>
	    <p><span>Sveukupno:</span> <span>{{ formatPrice(getTotalPrice) }} rsd</span></p>
      <p v-if="getTotalPrice < 3000"><span>Transport i dostava:</span> <span>Naplaćuje se po <a
            href="http://www.postexpress.rs/struktura/lat/cenovnik/cenovnik-unutrasnji-saobracaj.asp" target="_blank"
            rel="noopener" aria-label="link ka postexpress sajtu. otvara se u novoj stranici">cenovniku</a> kurirske
          službe</span></p>
      <p v-else><span>Transport i dostava:</span> <span>Besplatna</span></p>

      <p v-if="getCoupon"><span>Kodovi za popust:</span> <span>Primenjen kupon: {{ getCoupon.code }}</span></p>

      <p class="change_cart">Zaboravili ste da kupite artikal? <a :href="domain + 'shop/proizvodi'">Izmeni korpu</a></p>
    </div>
  </div>
</template>

<script>

import accounting from 'accounting';

export default {
  name: "CheckoutCart",

  data() {
    return {
      domain: domain,
    }
  },

  computed: {

    /**
     * Retrieve cart items from vuex store
     * That means on every change of vuex state, retrieve changes...
     */
    getCartItems() {

      return this.$store.getters['Cart/getCartItems'];
    },

    /**
     * Retrieve cart items count from vuex store
     */
    getCartItemsCount() {
      return this.$store.getters['Cart/getItemCount'];
    },

    /**
     * Retrieve cart items total price from vuex store
     */
    getTotalPrice() {
      return this.$store.getters['Cart/getTotalPrice'];
    },

    /**
     * Retrieve cart items sub-total price from vuex store
     */
    getSubTotalPrice() {
      return this.$store.getters['Cart/getSubTotalPrice'];
    },

    /**
     * Retrieve cart items total price without pdv from vuex store
     */
    getTotalWithoutPDV() {
      return this.$store.getters['Cart/getTotalWithoutPDV'];
    },

    /**
     * Retrieve cart items total pdv from vuex store
     */
    getTotalPDV() {
      return this.$store.getters['Cart/getTotalPDV'];
    },

    /**
     * Retrieve coupons code and total discount
     */
    getCoupon() {
      return this.$store.getters['Cart/getCoupon'];
    }

  },

  methods: {
    /**
     * Format price.
     *
     * @param value
     */
    formatPrice(value) {

      return accounting.formatMoney(value, '', 2, '.', ',')
    },

  },
}
</script>
